import { HandlerInfoProcess } from "../config/InfoTramiteComponents/HandlerInfoProcess";

interface Procedure {
    IDProcedureImp: number;
}

export const PersonalHistory = ({ IDProcedureImp }: Procedure) => {

    return (
        <>
            <HandlerInfoProcess _ProcedureIMPID={IDProcedureImp} />
        </>
    )
}